<div
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutAlign.lt-md="center center"
    [ngClass.gt-sm]="'blocks-container'"
    class="menu-container-parent"
>
    <div
        fxLayout="row"
        fxLayoutAlign="start start"
        fxLayoutGap="20px"
        class="menu-container"
        [ngClass.gt-sm]="'width50'"
        [ngClass.lt-md]="'width95'"
    >
        <div class="main-menu" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="30px">
            <div class="incoming-block mat-elevation-z10-light-shadow">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <mat-icon class="large">wifi_off</mat-icon>
                    <span class="block-label mat-headline">Dual Enrollment: Link To Advisors (DELTA) Temporarily Unavailable</span>
                </div>
                <p class="margin-top">
                    <span
                        >We're sorry, but the DELTA application is currently unavailable. We apologize for the inconvenience. This page
                        will continue checking to see if the system has become available again, and will transfer you to the login page
                        when the system is back online. Thank you for your patience during this outage.</span
                    >
                </p>
                <div class="margin-top">
                    <div class="margin-bottom-thin">Time until next check:</div>
                    <mat-progress-bar mode="determinate" [value]="(TimerCount * 100.0) / TimerMax" color="primary"></mat-progress-bar>
                </div>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/offline/offline.component.html